import { render, staticRenderFns } from "./VocabularyMemoPreview.vue?vue&type=template&id=1d537c26&lang=pug&"
import script from "./VocabularyMemoPreview.vue?vue&type=script&lang=js&"
export * from "./VocabularyMemoPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports